// Minimal client renderer for "Tulevat treenit" (first 6)
async function renderUpcomingFromWorker(options = {}) {
  const {
    api = "https://proud-violet-7d92.joonas-joensuu.workers.dev/api?room=1162319&range=month&filter=kendo",
    listId = "upcoming-trainings",
    maxItems = 6,
  } = options;

  const $list = document.getElementById(listId);
  if (!$list) return;

  const set = (html) => ($list.innerHTML = html);
  const esc = (s) =>
    String(s)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");

  // parse "YYYY-MM-DD HH:MM" (Helsinki-local string we got from the Worker)
  function parts(localStr) {
    const [dPart, tPart] = localStr.split(" ");
    const [y, m, d] = dPart.split("-").map(Number);
    const [hh, mm] = tPart.split(":").map(Number);
    // Build a Date in Europe/Helsinki by interpreting as local clock:
    // trick: make UTC Date from those parts, then read weekday using UTC.
    const dt = new Date(Date.UTC(y, m - 1, d, hh, mm));
    const wd = ["su", "ma", "ti", "ke", "to", "pe", "la"][dt.getUTCDay()];
    const ddmm = `${String(d).padStart(2, "0")}.${String(m).padStart(2, "0")}.`;
    const hm = `${String(hh).padStart(2, "0")}.${String(mm).padStart(2, "0")}`;
    return { wd, ddmm, hm };
  }

  function normalizeRoom(name) {
    const n = (name || "").trim();
    return n === "Eklöfska" ? "Eklöfska skolan" : n;
  }

  function li(item) {
    const a = parts(item.startLocal);
    const b = parts(item.endLocal);
    const room = esc(normalizeRoom(item.room));
    // Bold room name, drop organizer
    return `<li>${a.wd} ${a.ddmm} klo ${a.hm}–${b.hm} — <b>${room}</b></li>`;
  }

  try {
    set("<li>Ladataan…</li>");
    let data;
    const timestamp = Date.now();
    const oldTimestamp = localStorage.getItem("lastUpdate");
    const oldData = localStorage.getItem("lastData");
    const delta = timestamp - (oldTimestamp || 0);
    // console.log(oldData);

    if (delta > 5 * 60 * 1000 || !oldData) {
      const res = await fetch(api, { cache: "no-store" });
      if (!res.ok) {
        set(`<li class="text-danger">Virhe: ${res.status}</li>`);
        return;
      }
      data = await res.json();
      if (!data?.ok || !Array.isArray(data.items)) {
        set(
          `<li class="text-danger">${esc(
            data?.error || "Tietoja ei voitu hakea."
          )}</li>`
        );
        return;
      }

      localStorage.setItem("lastUpdate", timestamp);
      localStorage.setItem("lastData", JSON.stringify(data));
    } else {
      data = JSON.parse(oldData);
    }

    const now = Date.now();
    const items = data.items
      .filter((it) => it.startMs >= now)
      .sort((a, b) => a.startMs - b.startMs)
      .slice(0, maxItems);

    if (items.length === 0) {
      set("<li>Ei tulevia treenejä näkyvissä.</li>");
      return;
    }
    set(items.map(li).join(""));
  } catch (e) {
    console.error(e);
    set('<li class="text-danger">Virhe haettaessa treenejä.</li>');
  }
}

// Example usage on load:
document.addEventListener("DOMContentLoaded", () => {
  renderUpcomingFromWorker({
    api: "https://proud-violet-7d92.joonas-joensuu.workers.dev/api?room=1162319&range=month&filter=kendo",
    listId: "upcoming-trainings",
    maxItems: 6,
  });
});
